<template>

  <div>
    <!-- 导航标签 -->
    <span class="right-content__action" @click="showModal" v-if="url">
      <icon-font type="gb-icon-youjian_icon" />
      <span style="padding: 0 8px 0 4px">{{ $t('layouts.EmailMarketing') }}</span>
      <icon-font type="gb-icon-new_icon" class="icon_new" :hidden="ishidden"/>
    </span>

    <!-- 广告弹窗 -->
    <a-modal
      v-model="visible"
      centered :footer="null"
      :maskClosable="false"
      :width="420"
      style="padding: 0;"
      >
        <div class="base_box">
          <!-- 头部标题栏 -->
          <div class="top_box">
            <img src="../../assets/title.png" style="margin: -10px 0 -22px -14px;"/>
          </div>
          <!-- 内容区域 -->
          <div class="content_box">
            <img src="../../assets/element.png" />
            <div class="content_right">
              <div class="content_right_top">
                <span>本服务适合拥有ebay或独立站的卖家</span>
              </div>
              <div class="content_right_bottom">
                <span>可打通多平台数据进行用户分群，通过邮件方式对私域流量进行精准营销，ROI最高可达<span style="color: #FD8E00;font-weight: 800;">420%</span></span>
              </div>
            </div>
          </div>
          <!-- 底部栏 -->
          <div class="bottom_box">
            <img src="../../assets/tips.png" style="position: absolute;right: 17px;bottom: 50px;"/>
            <a href="javascript:void(0)" @click="toBytesku">
              <img src="../../assets/btn.png" style="margin-left: 8px"/>
            </a>
          </div>
        </div>
      </a-modal>
  </div>
</template>

<script>
import { authEdm } from '@/api/sso/subjectService'
import { QuerySystemParamsPage } from '@/api'
import { USER_INFO, ACCESS_TOKEN } from '@/store/mutation-types'
import { mapActions } from 'vuex'

export default {
  name: 'MenuTransform',
  data () {
    return {
      visible: false,
      ishidden: false,
      authEdmStatus: '',
      token: this.$ls.get(ACCESS_TOKEN),
      url: ''
    }
  },
  created () {
    this.getLocalStorage()
  },
  methods: {
    ...mapActions(['GetUserInfo']),
    showModal () {
      if (this.$ls.get(USER_INFO).authEdmStatus !== 1) {
        this.visible = true
      } else if (this.$ls.get(USER_INFO).authEdmStatus === 1) {
        if (this.url.includes('?')) {
          window.open(`${this.url}&source=erp&token=${this.token}`, '_blank')
        } else {
          window.open(`${this.url}?source=erp&token=${this.token}`, '_blank')
        }
      }
    },
    toBytesku () {
      this.visible = false
      authEdm({ authEbMStatus: 1 }).then(res => {
        this.ishidden = true
        this.GetUserInfo()
        if (this.url.includes('?')) {
          window.open(`${this.url}&source=erp&token=${this.token}`, '_blank')
        } else {
          window.open(`${this.url}?source=erp&token=${this.token}`, '_blank')
        }
      })
    },
    getLocalStorage () {
      QuerySystemParamsPage({
        paging: false,
        systemGroup: 'EDM_URL'
      }).then(res => {
        this.url = res.dataList?.[0]?.systemValue
      })
      if (this.$ls.get(USER_INFO).authEdmStatus === 1) {
        this.ishidden = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.right-content__action {
  position: relative;
  .icon_new {
    position: absolute;
    top: -5px;
    right: -13px;
    font-size: 38px;
  }
}
.base_box {
  width: 420px;
  // height: 420px;
  opacity: 1;
  border-radius: 7px;
  padding: 44px 26px 0 26px;
  background: url(../../assets/background_popups.png);
  // .top_box {

  // }
  .content_box {
    display: flex;
    .content_right {
      width: 149px;
      height: 157px;
      margin-top: 30px;
      .content_right_top {
        width: 149px;
        height: 44px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        text-align: center;
        line-height: 20px;
        color: #FE8F00;
        opacity: 1;
      }
      .content_right_bottom {
        width: 149px;
        height: 101px;
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 200;
        line-height: 20px;
        text-align: center;
        color: #FFFFFF;
        letter-spacing: 0px;
        opacity: 1;
      }
    }
  }
}
::v-deep .ant-modal-content {
  border-radius: 11px;
}
::v-deep .ant-modal-close-icon {
  position: absolute;
  top: 17px;
  right: 18px;
  font-size: 17.41px;
  color: white;
}
::v-deep .ant-modal-body {
  padding: 0!important;
}
</style>
